/* eslint-disable react/no-unused-state */
import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<
    { children: ReactNode },
    ErrorBoundaryState
> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: any) {
        console.error('Error occurred:', error, info);
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
                    <div className="max-w-md text-center">
                        <h1 className="ltr:text-4xl rtl:text-3xl font-bold text-gray-800 mb-4">
                            Oops! Something went wrong.
                        </h1>
                        <p className="text-gray-600 mb-6">
                            We’re sorry, but something went wrong. Please try
                            the following options:
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button
                                type="button"
                                onClick={() => window.location.reload()}
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700"
                            >
                                Refresh Page
                            </button>
                            <Link
                                to="/"
                                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg shadow-md hover:bg-gray-300"
                            >
                                Go to Home
                            </Link>
                        </div>
                        {/* <p className="mt-6 text-gray-500">
                            If the issue persists, please contact{' '}
                            <a
                                href="mailto:support@yourapp.com"
                                className="text-blue-600 underline"
                            >
                                support@reqter.com
                            </a>
                        </p> */}
                        {/* Optional Illustration */}
                        {/* <img
                            className="mt-8 w-64 mx-auto"
                            src="/assets/error-illustration.svg"
                            alt="Error Illustration"
                        /> */}
                    </div>
                </div>
            );
        }

        return children;
    }
}

export default ErrorBoundary;
